import {Pipe, PipeTransform} from '@angular/core';
import {TableSorter} from "../../tools/table-sorter/table-sorter";

@Pipe({
  name: 'tableSort',
  standalone: true,
  pure: false
})
export class TableSortPipe implements PipeTransform {

  transform(tableRows: any[], tableSorter: TableSorter): any[] {

    if (!Array.isArray(tableRows)) {
      return tableRows;
    }

    tableRows.sort((a: any, b: any): number => {
      const field = tableSorter.sortName;
      const order = tableSorter.sortOrder === 'asc' ? 1 : -1;

      let valueA = a[field];
      let valueB = b[field];

      if (valueA === null || valueA === undefined) {
        valueA = '';
      } else if (typeof valueA === 'string' && this.isNumeric(valueA)) {
        valueA = parseFloat(valueA);
      } else if (typeof valueA === 'string') {
        valueA = valueA.toUpperCase();
      }

      if (valueB === null || valueB === undefined) {
        valueB = '';
      } else if (typeof valueB === 'string' && this.isNumeric(valueB)) {
        valueB = parseFloat(valueB);
      } else if (typeof valueB === 'string') {
        valueB = valueB.toUpperCase();
      }

      if (valueA < valueB) {
        return -order;
      } else if (valueA > valueB) {
        return order;
      } else {
        return 0;
      }
    });

    return tableRows;
  }

  isNumeric(num: any): boolean {
    return !isNaN(num)
  }
}
